import React, { useCallback, forwardRef } from 'react';
import PropTypes from 'prop-types';
import history from '@sendpayments/js-utils/dist/services/history';
import { track, eventTypes } from '@sendpayments/js-utils/dist/services/analytics/legacy';

const handleAnalyticsComponentWraHoc = (InternalComponent, info) => {
  const HandleAnalyticsComponentWrapper = forwardRef(({ onChange, onClick, ...props }, ref) => {
    // store the url of the component
    const path = history.location.pathname;

    const onClickWrapperHandler = useCallback((e, ...params) => {
      const { name } = e && e.target;

      // send event to analytics
      track.event(eventTypes.CLICK, {
        path,
        name: info ? `${info}${name || ''}` : name,
      });

      // trigger original event
      onClick(e, ...params);
    });

    const onChangeWrapperHandler = useCallback((e, ...params) => {
      const { name, value } = (e && e.target) || { value: e || 'Changed' };

      // send event to analytics
      track.event(eventTypes.INPUT_CHANGE, {
        path,
        name: info ? `${info}${name || ''}` : name,
        value,
      });

      // trigger original event
      onChange(e, ...params);
    });

    return <InternalComponent ref={ref} onClick={onClickWrapperHandler} onChange={onChangeWrapperHandler} {...props} />;
  });

  HandleAnalyticsComponentWrapper.propTypes = {
    onChange: PropTypes.func,
    onClick: PropTypes.func,
  };

  HandleAnalyticsComponentWrapper.defaultProps = {
    onChange: () => {},
    onClick: () => {},
  };

  return HandleAnalyticsComponentWrapper;
};

const withAnalytics = (components, { info } = {}) =>
  Object.entries(components).reduce((acc, [componentName, Component]) => {
    acc[componentName] = handleAnalyticsComponentWraHoc(Component, info);
    return acc;
  }, {});

export default withAnalytics;
